import { gql } from "@apollo/client/core";

export const GET_ACTIVE_MESSAGES = gql`
  query {
    getActiveOHLQMessages {
      audience
      fromDate
      key
      messageId
      status
      text
      toDate
      type
    }
  }
`;
